<script>
   import Layout from '../../layouts/main'
   // import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment';

   export default {
      page: {
         title: "Add Order",
         meta: [
         {
            name: "description",
            content: appConfig.description,
         },
         ],
      },
      components: { Layout},
      data() {
         const current_date = moment().format("YYYY-MM-DD");
         const bill_date = moment().format("YYYY-MM-DD-hh-mm-ss");
         return {
            title: "Billing",
            items: [
            {
               text: "",
               href: "/orders",
            },
            {

              text: "",
              active: true,
           },        
           ],
         products: [],

         order: {
            name: '',
            country_code: 1,
            mobile: '',
            payment_type: 2,
            package: 2,
         },        

         inputs: [
            {
               product_id: '',
               product_keyword: '',
               product_visible: false,
               quantity_type: 1,
               quantity: '',
               products: [],
               price: '',
               stock: '',
               is_apply: true,
               is_edit: false,
               err: {
                  // product_id: '',
                  // quantity: ''
               },
               in_stock: false,
            }
         ],

         total_count: 0,

         errors: {},
         today: current_date,
         bill_date: bill_date,
         total: 0,
         summary: [],
      };
   },
   mounted() {},
   created() {
      this.fetchAllProducts();
      this.fetchPendingOrders();
      // alert(moment());
   },

   methods: {
      numbersOnly(event) {
         let keyCode = event.keyCode;
         if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
         }
      }, 
      getToken() {
         if (localStorage.getItem('sigofish_store')) {
            var sigofish_store =  JSON.parse(localStorage.getItem('sigofish_store'));
            if(sigofish_store.token) {
               this.token = sigofish_store.token;
            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "login" });
            }
               
         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "login" });
         }
      }, 

      fetchAllProducts() {
            let url = "store/store_products?keyword=";         
            this.getToken();
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.products = responseData.products;
            })
            .catch((err) => console.log(err));
      },

      closeProductSearch(i) {
         // alert(i);
         this.inputs[i].product_visible = false;       
         this.inputs[i].product_keyword = '';
         this.inputs[i].price = '';
         this.inputs[i].stock = '';
         // this.inputs[i].quantity = '';
      },

      setProduct(i) {
         this.inputs[i].product_keyword = event.target.options[event.target.options.selectedIndex].label;
         this.inputs[i].product_visible = false;
         for(var j = 0; j < this.inputs[i].products.length; j++) {
            
            if(this.inputs[i].products[j].id == this.inputs[i].product_id) {
               
               this.inputs[i].price = parseFloat(this.inputs[i].products[j].price).toFixed(2);
               this.inputs[i].stock = parseFloat(this.inputs[i].products[j].stock).toFixed(2);
            }
         }
         
      },

      fetchProducts(i) { 

         let products = this.products;
        
         if (this.inputs[i].product_keyword != '' && this.inputs[i].product_keyword) {
            products = products.filter((item) => {
                return item.name
                  .toUpperCase()
                  .includes(this.inputs[i].product_keyword.toUpperCase())

              })
         }      

         // if(this.inputs[i].product_keyword){
         //    products = products.filter((item)=>{
         //       return this.inputs[i].product_keyword.toLowerCase().split(' ').every(v => item.name.toLowerCase().includes(v))
         //    })
         // } 

         // products = products.map(item => {
         //    return item.name.indexOf(this.inputs[i].product_keyword) != -1;
         // });
        
         this.inputs[i].products = products;
         console.log(this.inputs[i].products);
         this.inputs[i].product_visible = true;
         
      },       

      add() {
         this.inputs.push(
            {
               product_id: '',
               product_keyword: '',
               product_visible: false,
               quantity_type: 1,
               quantity: '',
               products: [],
               price: '',
               stock: '',
               is_apply: true,
               is_edit: false,
               err: {
                  // product_id: '',
                  // quantity: ''
               },
               in_stock: false,
            }
         );
      },

      remove(index) {
         var product_id = this.inputs[index].product_id;
         this.inputs.splice(index, 1);

         var i;
         i = this.summary.findIndex(function(element) {
            return product_id === element.product_id;
         });

         if(i == -1) {  
            this.$swal("", "Item not found", "error");
         } else {         
            this.total = this.total - this.summary[i].total_price;
            this.summary.splice(i, 1);
            
         } 
      }, 

      apply(index) {  
         let err = {
            product_id: [],
            quantity: []
         };
         this.inputs[index].err = err;

         let is_valid = true;
         if(this.inputs[index].product_id == '') {
            this.inputs[index].err.product_id[0] = 'Please select an item';
            is_valid = false;
         } 

         if(this.inputs[index].quantity == '') {
            this.inputs[index].err.quantity[0] = 'Please enter quantity';
            is_valid = false;
         }  

         if(is_valid) {

            this.getToken();
            this.errors = {};
               
            const config = {
                  headers: {
                     "Content-type": "multipart/form-data",
                     "Accept": "application/json",
                     "Authorization": "Bearer " + this.token,
                  },
            };

            let url = "store/order/check"; 
          
            let formData = new FormData();
            formData.append("product_id", this.inputs[index].product_id); 
            formData.append("quantity_type", this.inputs[index].quantity_type);
            formData.append("quantity", this.inputs[index].quantity);           
            this.$axios
            .post(url, formData, config)
            .then((res) => {
               console.log(res);
               if(res.status == 200) {
                  var obj = {};
                  obj.product_id = this.inputs[index].product_id;
                  obj.item = this.inputs[index].product_keyword;
                  obj.qty = this.inputs[index].quantity;
                  obj.quantity_type = this.inputs[index].quantity_type
                  var weight;
                  if(this.inputs[index].quantity_type == 1) {
                     weight = this.inputs[index].quantity;
                  } else {
                     weight = this.inputs[index].quantity/1000;
                  }
                  obj.quantity = weight;
                  obj.total_price = weight * this.inputs[index].price;
                  this.summary.push(obj);  
                  this.inputs[index].is_apply = false;
                  this.inputs[index].is_edit = true;
                  this.total = this.total + obj.total_price;
                  console.log(this.summary);
                  
               } else {
                  this.$swal("", "Sorry, There is no enough stock", "error");
               }
            })
            .catch((error) => {
               if (error.response) {
                  if(error.response.status == 422) { 
                     this.$swal("", error.response.data.message, "error");
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            });
            this.inputs[index].err = {};
         }
        
      },

      update(index) {
         var product_id = this.inputs[index].product_id;
         var i;
         i = this.summary.findIndex(function(element) {
            return product_id === element.product_id;
         });
         
         if(i == -1) {  
            this.$swal("", "Item not found", "error");
         } else {      
            let err = {
               product_id: [],
               quantity: []
            };
            this.inputs[index].err = err;

            let is_valid = true;
            if(this.inputs[index].product_id == '' && this.inputs[index].product_keyword == '') {
               this.inputs[index].err.product_id[0] = 'Please select an item';
               is_valid = false;
            } 

            if(this.inputs[index].quantity == '') {
               this.inputs[index].err.quantity[0] = 'Please enter quantity';
               is_valid = false;
            }  

            if(is_valid) {  
               this.getToken();
               this.errors = {};
                  
               const config = {
                     headers: {
                        "Content-type": "multipart/form-data",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + this.token,
                     },
               };

               let url = "store/order/check"; 
             
               let formData = new FormData();
               formData.append("product_id", this.inputs[index].product_id); 
               formData.append("quantity_type", this.inputs[index].quantity_type);
               formData.append("quantity", this.inputs[index].quantity);           
               this.$axios
               .post(url, formData, config)
               .then((res) => {
                  console.log(res);
                  if(res.status == 200) {
                     this.total = this.total - this.summary[i].total_price;
                     this.summary[i].product_id = this.inputs[index].product_id;
                     this.summary[i].item = this.inputs[index].product_keyword;
                     this.summary[i].qty = this.inputs[index].quantity;
                     this.summary[i].quantity_type = this.inputs[index].quantity_type;
                     var weight;
                     if(this.inputs[index].quantity_type == 1) {
                        weight = this.inputs[index].quantity;
                     } else {
                        weight = this.inputs[index].quantity/1000;
                     }
                     this.summary[i].quantity = weight;
                     this.summary[i].total_price = weight * this.inputs[index].price;
                     this.total = this.total + this.summary[i].total_price;
                  } else {
                     this.$swal("", "Sorry, There is no enough stock", "error");
                     
                  }
                  
               })
               .catch((error) => {
                  if (error.response) {
                     if(error.response.status == 422) { 
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               });
               this.inputs[index].err = {};
            }
         } 
      },

      reset() {
         this.order = {
            name: '',
            country_code: 1,
            mobile: '',
            payment_type: 2,
            package: 2,
         };      

         this.inputs = [
            {
               product_id: '',
               product_keyword: '',
               product_visible: false,
               quantity_type: 1,
               quantity: '',
               products: [],
               price: '',
               stock: '',
               is_apply: true,
               is_edit: false,
               err: {
                  // product_id: '',
                  // quantity: ''
               },
               in_stock: false,

            }
         ] ;

         this.errors = {};
         this.total = 0;
         this.summary = [];
      },

      showModal(modal) {
         this.$refs[modal].show();
      },

      hideModal(modal) {
         this.$refs[modal].hide();
      },  

      checkStock(product_id, quantity_type, quantity, i) {

         this.getToken();
         this.errors = {};
            
         const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
         };

         let url = "store/order/check";  

       
         let formData = new FormData();
         formData.append("product_id", product_id); 
         formData.append("quantity_type", quantity_type);
         formData.append("quantity", quantity);           
         //var response;   
         this.$axios
         .post(url, formData, config)
         .then((res) => {
            console.log(res);
            if(res.status == 200) {
               this.inputs[i].in_stock = true;
               //response =  1;
            } else {
               this.inputs[i].in_stock = false;
               //response = 2;
            }
                  
            
         })
         .catch(() => {
            this.inputs[i].in_stock = false;
            //response = 2;
         });

         //return response;
      },  

      createOrder() {

         this.getToken();
         //alert(this.order.package);
         this.errors = {};
            
         const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
         };

         let url = "store/order/add";  

       
         let formData = new FormData();
         formData.append("name", this.order.name); 
         formData.append("country_code", this.order.country_code);
         formData.append("mobile", this.order.mobile);  
         formData.append("payment_type", this.order.payment_type);         
         formData.append("package", this.order.package); 
         var i = 0;
         this.summary.forEach(obj => {
               
            formData.append('product_ids[' + i + ']', obj.product_id);
            formData.append('quantities[' + i + ']', obj.qty);
            formData.append('quantity_types[' + i + ']', obj.quantity_type);
            i++;
         });
            
         this.$axios
         .post(url, formData, config)
         .then((res) => {
            if(res.status == 200) {
                  
                     this.reset();
                     this.$router.push({ name: 'orders.add'});
            } else {
               this.$swal("", "Something went wrong", "error");
            }
                  
            console.log(res);
         })
         .catch((error) => {
            if (error.response) {
               if(error.response.status == 422) {               
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                     console.log(this.errors);
                  } 
                  this.$swal("", error.response.statusText, "error");
                        
               } else if(error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");

               } else if(error.response.status == 401) {
                  this.$swal("", error.response.statusText, "error");
                  this.$router.push({ name: "login" });
                        
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            } else {
               this.$swal("", error.message, "error");
            }
         })
         .finally(() => (this.loading = false));
      },


      async bill() {
         this.getToken();
         this.errors = {};

         let url = "store/order/bill";  

         const config = {
            headers: {
               "Content-type": "application/json",
               "Accept": "application/json",
               "Authorization": "Bearer " + this.token,
            },
            responseType: "arraybuffer",
         };

       
         let formData = new FormData();
         formData.append("name", this.order.name); 
         formData.append("country_code", this.order.country_code);
         formData.append("mobile", this.order.mobile);  
         formData.append("payment_type", this.order.payment_type); 
         formData.append("package", this.order.package);         

         var i = 0;
         this.summary.forEach(obj => {
               
            formData.append('product_ids[' + i + ']', obj.product_id);
            formData.append('quantities[' + i + ']', obj.qty);
            formData.append('quantity_types[' + i + ']', obj.quantity_type);
            i++;
         });

         // this.getToken();

         this.$axios
         .post(url,formData, config)
         .then((response) => {
            //console.log(response);            
            
            if(response.status == 200) {  

               this.reset();             

               let blob = new Blob([response.data], { type: "application/pdf" });
               // let link = document.createElement("a");
               // link.href = window.URL.createObjectURL(blob);
            
               // //let filename = "bill" + this.bill_date +  ".pdf";
               // //link.download = filename;

               // link.target = '_blank';
               // link.click();

               var blob_url = window.URL.createObjectURL(blob);
               let iframe =  document.createElement('iframe'); //load content in an iframe to print later
               document.body.appendChild(iframe);

               iframe.style.display = 'none';
               iframe.src = blob_url;

               return new Promise(function () { 
                  window.setTimeout(function() {
                     iframe.contentWindow.print();
                  }, 1000)
               }).then(function () {
                  this.$router.push({ name: 'orders.add'});
               });            
               
            } else {
               this.$swal("", "Something went wrong", "error");
            }
                  
         })
         .catch((error) => {
            if (error.response) {
               if(error.response.status == 422) {               
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                     console.log(this.errors);
                  } 
                  this.$swal("", error.response.statusText, "error");
                        
               } else if(error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");

               } else if(error.response.status == 401) {
                  this.$swal("", error.response.statusText, "error");
                  this.$router.push({ name: "login" });
                        
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            } else {
               this.$swal("", error.message, "error");
            }
         })
         .finally(() => (this.loading = false));
      }, 
      
      
      fetchPendingOrders() {
            let url = "store/orders/pending_orders";         
            this.getToken();
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.total_count = responseData.total_count;
            })
            .catch((err) => console.log(err));
      },

         
   }
}
</script>

<style type="text/css">
   label {
      font-size: 12px;
   }
</style>

<template>
   <Layout>
      <!-- <PageHeader :title="title" :items="items" /> -->
      <div class="row">
         <div class="col-12">
            <div class="page-title-box d-flex align-items-center justify-content-between">
            <h4 class="mb-0 font-size-18">Billing</h4>

            <div class="page-title-right">
               <!-- <button class="btn btn-primary">Pending ({{total_count}})</button> -->
               <router-link :to="{ name: 'online.orders' }" class="btn btn-danger me-2 mb-2 " >Pending Orders : {{total_count}}</router-link>
            </div>
            </div>
         </div>
      </div>
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- @submit.prevent="createOrder()" -->
                  <form class="form-horizontal" role="form" >
                     <div class="row">
                        <div class="col-xl-7 col-lg-6">
                        
                           <b-card header-class="bg-transparent border-light" class="border border-light mb-3">
                              <div class="row">                          
                                 <b-form-group class="col-lg-6 mb-1">
                                    <label>Customer Name</label>
                                    <b-form-input v-model="order.name" v-bind:class="{ 'is-invalid': Boolean(errors.name) }"></b-form-input>

                                    <div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                                 </b-form-group>

                                 <b-form-group class="col-lg-6 mb-1">
                                    <label>Mobile</label>
                                    <b-input-group size="sm" prepend="+91">
                                       <b-form-input v-model="order.mobile" v-bind:class="{ 'is-invalid': Boolean(errors.mobile) }" maxlength="10" @keypress="numbersOnly"></b-form-input>
                                    </b-input-group>
                                    <div v-for="(val, index) in errors.mobile" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                                 </b-form-group>  
                              </div>
                           </b-card>

                           <b-card header-class="bg-transparent border-light" class="border border-light mb-3" v-for="(input, index) in inputs" :key="index">
                              <b-row>  
                                 <b-col lg="10" class="form-group">
                                    <label class="control-label">Item <span class="text-danger">*</span></label>
                                    <div class="search-select">
                                       <!-- <span class="search-close" v-if="input.product_visible" @click="closeProductSearch(index)"><i class="dripicons dripicons-cross"></i></span> -->

                                       <b-form-input v-model="input.product_keyword"  @keyup="fetchProducts(index)" autocomplete="off" placeholder="Search here..." v-bind:class="{ 'is-invalid': Boolean(input.err && input.err.product_id) }" :disabled="input.is_edit"></b-form-input>
                                       <div v-if="Boolean(input.err)">
                                       <div v-for="(val, index) in input.err.product_id" :key="index" class="invalid-feedback">
                                             <p class="mb-0">{{ val }}</p>
                                       </div> </div>  

                                       <b-form-select class="form-control" v-if="input.product_visible && Boolean(input.products.length)" v-model="input.product_id" :select-size="input.products.length < 10 ? (input.products.length <= 1 ? 2 : input.products.length) : 10" @change="setProduct(index)">
                                          <b-form-select-option v-for="product in input.products" :key="product.id" :value="product.id" :title="product.name">{{ product.name }} </b-form-select-option>
                                       </b-form-select>

                                       <b-form-select class="form-control" v-if="input.product_visible && !Boolean(input.products.length)" v-model="input.product_id" :select-size="2">                  
                                          <b-form-select-option :value="0" disabled>No results...</b-form-select-option>
                                       </b-form-select>
                                    
                                    </div>                           
                                 </b-col>

                                 <b-col lg="2" class="me-0" style="margin-top: 27px;">
                                       <button v-if="input.is_apply" class="btn btn-secondary float-end" type="button" @click="closeProductSearch(index)">Clear</button>
                                 </b-col>
                              </b-row>

                                 <b-row>
                                    <b-col xl="3" lg="4" class="pe-0">                                                            
                                       <b-form-radio-group v-model="input.quantity_type">
                                          <label class="control-label">  <span class="text-danger">*</span></label>
                                          <div class="form-check-inline me-1">
                                             <b-form-radio name="quantity_type"  value="1"> Kg</b-form-radio>   
                                          </div>
                                          <div class="form-check-inline me-1">
                                             <b-form-radio  name="quantity_type" value="2">gm</b-form-radio>
                                          </div>
                                       </b-form-radio-group>
                                       <b-form-input type="number" min=".1" step="any" v-model="input.quantity" v-bind:class="{ 'is-invalid': Boolean(input.err && input.err.quantity) }" placeholder="Quantity"></b-form-input>
                                       <div v-if="Boolean(input.err)">
                                          <div v-for="(val, index) in input.err.quantity" :key="index" class="invalid-feedback">
                                                <p class="mb-0">{{ val }}</p>
                                          </div>   
                                       </div>
                                    </b-col>

                                    <b-col xl="2" lg="4" class="pe-0">
                                       <label  class="control-label">Stock(kg)</label>
                                       <b-input-group >
                                          <b-form-input disabled v-model="input.stock"></b-form-input>
                                       </b-input-group>
                                    </b-col>

                                    <b-col xl="3" lg="4" class="pe-0">
                                       <label>Price (per kg)</label>
                                       <b-input-group size="sm" prepend="Rs.">
                                          <b-form-input disabled v-model="input.price"></b-form-input>
                                       </b-input-group>
                                    </b-col>
                                 <!-- </b-row> -->

                                 <b-col xl="4" lg="12" class="form-group mt-2">                             
                                    <div class="float-end" style="margin-top: 29px;">
                                       <!-- <b-col xl="4" class="control-label" style="margin-top: 29px;"> -->
                                       <button v-if="input.is_apply" class="btn btn-primary btn-sm me-2" type="button" @click="apply(index)">Apply </button>
                                       <button v-if="input.is_edit" class="btn btn-primary btn-sm me-2" type="button" @click="update(index)">Update</button>
                                       <button class="btn btn-success btn-sm me-2" type="button" @click="add()" v-show="index == inputs.length-1"><i class="fas fa-plus"></i></button>
                                       <button class="btn btn-danger btn-sm rounded-0"  type="button" @click="remove(index)" v-show="index || ( !index && inputs.length > 1)"><i class="fa fa-trash"></i></button>
                                    </div>
                                 </b-col>
                                 </b-row>
                           </b-card>                            
                         
                        </div><!--end of left col--> 
                  
                        <div class="col-xl-5 col-lg-6">
                           <b-card bg-variant="light" class=" mb-3" v-bind:class="{ 'is-invalid': Boolean(errors.product_ids) || Boolean(errors.quantities) || Boolean(errors.quantity_types) }">
                              <h5 class="pb-2" style="border-bottom: 1px dashed #999;">Order Summary<span class="float-end font-size-13">Date: {{today | formatDate}}</span></h5>
                              <div class="table-responsive">
                                 <table class="table table-borderless mb-0">
                                    <thead>
                                       <tr>
                                          <th>Item</th>
                                          <th class="text-right">Qty(kg)</th>
                                          <th class="text-right">Price</th>
                                       </tr>
                                    </thead>
                                    <tbody class="font-size-12">
                                       <tr v-for="(order, index) in summary" :key="index">
                                          <td style="overflow-wrap: anywhere;">{{order.item}}</td>
                                          <td class="text-right">{{parseFloat(order.quantity).toFixed(3)}}</td>
                                          <td class="text-right">Rs.{{parseFloat(order.total_price).toFixed(2)}}</td>
                                       </tr>
                                    </tbody>
                                 </table>
                              </div>
                              <h5 class="font-size-13 p-2" style="border-top: 1px dashed #999;">Total<span class="float-end">Rs.{{parseFloat(total).toFixed(2)}}</span></h5>
                           </b-card>
                           <div v-for="(val, index) in errors.product_ids" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                           </div>
                           <div v-for="(val, index) in errors.quantities" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                           </div>
                           <div v-for="(val, index) in errors.quantity_types" :key="index" class="invalid-feedback">
                                 <p class="mb-2">{{ val }}</p>
                           </div>

                           <b-card header-class="bg-transparent border-light" class="border border-light mb-2">
                              <div class="row">                              
                                 <b-col md="12">
                                    <label class="control-label">Payment Type <span class="text-danger">*</span></label>
                                    <b-form-radio-group v-model="order.payment_type" name="payment_type" v-bind:class="{ 'is-invalid': Boolean(errors.payment_type) }"> 
                                       <div class="form-check-inline" > 
                                          <b-form-radio :value="1" class="mr-5"><span class="font-size-13">Online Payment</span></b-form-radio> 
                                       </div>
                                       <div class="form-check-inline">  
                                          <b-form-radio :value="2"><span class="font-size-13">Cash Payment</span></b-form-radio>
                                       </div>
                                    </b-form-radio-group>
                                    <div v-for="(val, index) in errors.payment_type" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                                 </b-col>
                              </div>
                           </b-card>
                           <b-card header-class="bg-transparent border-light" class="border border-light">
                              <div class="row">

                                 <b-col md="12">
                                    <!-- <div class="form-check form-check-primary">
                                       <input
                                       class="form-check-input"
                                       type="checkbox"
                                       id="packagecharge"
                                       value="1"
                                       unchecked-value="2"
                                       v-model="order.package"
                                       />
                                          <label class="form-check-label" for="packagecharge">
                                             Package Charge
                                          </label>
                                    </div> -->
                                    <b-form-checkbox
                                       id="package-charge"
                                       v-model="order.package"
                                       value="1"
                                       unchecked-value="2"
                                    >
                                       <span class="ms-1">Packing Charge - Rs:10</span>
                                    </b-form-checkbox>
                                 </b-col>
                              </div>                     
                           </b-card>

                           <div class="row mt-3">
                              <div class="col-lg-12 ">
                                 <div class="float-end">
                                    <button class="btn btn-outline-primary me-2" type="button" @click="reset()">Reset</button>
                                    <button class="btn btn-primary me-2" type="button" @click="createOrder()">Save</button>
                                    <button class="btn btn-primary me-2" type="button" @click="bill()">Save & Print</button>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div> 
                  </form>    
               </div>
            </div>
         </div>
      </div>

   </Layout>
</template>
